import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";

const field = "w-full bg-[var(--nl-bg-3)] border border-white/10 px-4 py-3.5 text-white font-body focus:outline-none focus:border-gold focus:ring-1 focus:ring-[var(--nl-gold)] transition-colors duration-300";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grain relative flex items-center justify-center bg-[var(--nl-bg)] px-6" data-testid="admin-login-page">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-md border border-white/10 bg-[var(--nl-bg-2)] p-10"
      >
        <Link to="/" className="flex items-baseline gap-1 mb-8 justify-center">
          <span className="font-serif text-2xl">Namarck</span>
          <span className="font-serif text-2xl italic text-gold">Limo</span>
        </Link>
        <p className="label text-gold text-center mb-2">Concierge Access</p>
        <h1 className="font-serif font-light text-4xl text-center mb-8">Admin Sign In</h1>

        <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
          <div>
            <label className="label text-white/50 block mb-2">Email</label>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className={field} data-testid="login-email" />
          </div>
          <div>
            <label className="label text-white/50 block mb-2">Password</label>
            <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className={field} data-testid="login-password" />
          </div>
          {error && <p className="text-red-400 text-sm font-body" data-testid="login-error">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            className="w-full label bg-gold text-black py-4 hover:bg-[var(--nl-gold-hover)] transition-colors duration-300 disabled:opacity-60"
            data-testid="login-submit"
          >
            {loading ? "Signing in…" : "Enter Dashboard"}
          </button>
        </form>
        <Link to="/" className="block text-center label text-white/40 hover:text-gold mt-8 transition-colors duration-300">← Back to site</Link>
      </motion.div>
    </div>
  );
}
